var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
import { __decorate, __metadata } from "tslib";
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Actions, Mutations } from '@/store/enums/hrgs/master/CompetencyUnitEnum';
import ApiService from '@/core/services/ApiService';
import { ElMessage } from 'element-plus';
import { Pagination } from '@/core/enums/Pagination';
import { hrgsSwalAlert } from '@/core/helpers/sweet-alert';
const API_URL = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_MOBA_WEBAPI}`;
const API_URLS = {
    url: `${API_URL}/api/competencyunits`
};
let CompetencyUnitModule = class CompetencyUnitModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.competencyUnitList = [];
        this.loading = false;
        this.pagination = {
            totalPage: 0,
            totalPageSize: 0,
            startPaginationIndex: 0,
            endPaginationIndex: 0,
            currentPage: 1
        };
        this.filter = {
            code: '',
            title: '',
            schemeId: ''
        };
        this.orderBy = null;
    }
    // *GETTERS
    get getCompetencyUnitList() {
        return this.competencyUnitList;
    }
    get getCompetencyUnitListLoading() {
        return this.loading;
    }
    get getCompetencyUnitListFilter() {
        return this.filter;
    }
    get getCompetencyUnitListPagination() {
        return this.pagination;
    }
    // *MUTATIONS
    [_a = Mutations.SET_COMPETENCY_UNIT_LIST](data) {
        this.competencyUnitList = data;
    }
    [_b = Mutations.SET_COMPETENCY_UNIT_LIST_LOADING](data) {
        this.loading = data;
    }
    [_c = Mutations.SET_COMPETENCY_UNIT_LIST_FILTER](data) {
        this.filter = Object.assign(Object.assign({}, this.filter), data);
    }
    [_d = Mutations.RESET_COMPETENCY_UNIT_LIST_FILTER]() {
        this.filter = {
            code: '',
            title: '',
            schemeId: ''
        };
    }
    [_e = Mutations.SET_COMPETENCY_UNIT_LIST_PAGINATION](data) {
        const totalPage = data.totalItems || 0;
        const totalPageSize = data.pageSize || this.pagination.totalPageSize;
        const currentPage = data.currentPage || this.pagination.currentPage;
        this.pagination = {
            totalPage,
            totalPageSize,
            currentPage,
            startPaginationIndex: 0,
            endPaginationIndex: Math.floor(totalPage / totalPageSize)
        };
    }
    [_f = Mutations.SET_ORDER](data) {
        this.orderBy = data;
    }
    // *start: ACTION
    [_g = Actions.GET_LIST](payload) {
        var _p, _q, _r;
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const filter = `SearchValues=${((_p = this.filter) === null || _p === void 0 ? void 0 : _p.code) || ''}&SearchValues=${((_q = this.filter) === null || _q === void 0 ? void 0 : _q.title) || ''}`;
        const params = Object.assign(Object.assign({ ver: 'v1', pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE, pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO }, (((_r = this.filter) === null || _r === void 0 ? void 0 : _r.schemeId) && {
            schemeId: this.filter.schemeId
        })), (this.orderBy && {
            orderBy: this.orderBy
        }));
        this.context.commit(Mutations.SET_COMPETENCY_UNIT_LIST_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}?${filter}&${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                this.context.commit(Mutations.SET_COMPETENCY_UNIT_LIST, resData.data);
                this.context.commit(Mutations.SET_COMPETENCY_UNIT_LIST_PAGINATION, {
                    currentPage: params.pageNo,
                    pageSize: params.pageSize,
                    totalItems: resData.totalRecords
                });
                resolve(resData.data);
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get competency unit list.'
                });
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_COMPETENCY_UNIT_LIST_LOADING, false);
            });
        });
    }
    [_h = Actions.GET_DETAIL](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/${payload.id}?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const data = response.data.result.content;
                resolve(data);
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get competency unit details.'
                });
                reject(error);
            });
        });
    }
    [_j = Actions.POST_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = payload.data;
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed create competency unit.'
                });
                reject(_response);
            });
        });
    }
    [_k = Actions.UPDATE_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = payload.data;
        return new Promise((resolve, reject) => {
            ApiService.put(`${API_URLS.url}/${employeeID}/${payload.id}?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed update competency unit.'
                });
                reject(_response);
            });
        });
    }
    [_l = Actions.DELETE_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API_URLS.url}/${employeeID}/${payload.id}?${new URLSearchParams(params).toString()}`)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else {
                    this.context.dispatch(Actions.GET_LIST);
                    resolve(res.data.statusCode);
                }
            })
                .catch((response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed delete competency unit.'
                });
                reject(response);
            });
        });
    }
    [_m = Actions.CHANGE_EXPORT]() {
        var _p, _q;
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const filter = `SearchValues=${((_p = this.filter) === null || _p === void 0 ? void 0 : _p.code) || ''}&SearchValues=${((_q = this.filter) === null || _q === void 0 ? void 0 : _q.title) || ''}`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/exportchange?${filter}&${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    [_o = Actions.DOWNLOAD](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1',
            fileName: (payload === null || payload === void 0 ? void 0 : payload.fileName) || ''
        };
        return new Promise((resolve, reject) => {
            ApiService.getBlob(`${API_URLS.url}/${employeeID}/download?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', params.fileName);
                document.body.appendChild(link);
                link.click();
                resolve();
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], CompetencyUnitModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CompetencyUnitModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CompetencyUnitModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompetencyUnitModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CompetencyUnitModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CompetencyUnitModule.prototype, _f, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CompetencyUnitModule.prototype, _g, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CompetencyUnitModule.prototype, _h, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CompetencyUnitModule.prototype, _j, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CompetencyUnitModule.prototype, _k, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CompetencyUnitModule.prototype, _l, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompetencyUnitModule.prototype, _m, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CompetencyUnitModule.prototype, _o, null);
CompetencyUnitModule = __decorate([
    Module
], CompetencyUnitModule);
export default CompetencyUnitModule;
